// src/actions/checkout/placeorderActions.js
import { SubscribePlanApi } from "../../api/subscribe/subscribeApi";
import { SUBSCRIBE_SUCCESS, SUBSCRIBE_FAILURE, CLEAR_SUBSCRIBE } from "../types";

export const subcribePlanSuccess = (placeorder) => ({
  type: SUBSCRIBE_SUCCESS,
  payload: placeorder,
});

export const subcribePlanFailure = (error) => ({
  type: SUBSCRIBE_FAILURE,
  payload: error,
});

export const subcribePlanOrder = (error) => ({
  type: CLEAR_SUBSCRIBE,
});

export const subcribePlan = (postData) => {
  return (dispatch) => {
    SubscribePlanApi(postData)
      .then((response) => {
        dispatch(subcribePlanSuccess(response.data));
      })
      .catch((error) => {
        console.log("error");
        console.log(error);
        dispatch(subcribePlanFailure(error.message));
      });
  };
};
